import {DefaultGroupsIDs, HomepageGroupType} from './enums';
import texts from './texts';
import {getUuid4} from '.././../utils/getUuid4';
import {Group} from './store/HomepageStore';
import {MAX_GROUPS_COUNT} from './constants';

export const getGreetingBasedOnTime = () => {
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) {
        return texts.greeting_morning;
    } else if (hour >= 12 && hour < 16) {
        return texts.greeting_afternoon_1;
    } else if (hour >= 16 && hour < 18) {
        return texts.greeting_afternoon_2;
    } else if (hour >= 18 && hour < 22) {
        return texts.greeting_evening;
    }
    return texts.greeting_night;
};

export const getGroupTitle = (title: string) => {
    if (title === DefaultGroupsIDs.insights) {
        return texts.insights_title;
    } else if (title === DefaultGroupsIDs.shortcuts) {
        return texts.shortcuts_title;
    }
    return title;
};

export const getGroupId = (title: string): string => {
    if (title === DefaultGroupsIDs.shortcuts) {
        return DefaultGroupsIDs.shortcuts;
    } else if (title === DefaultGroupsIDs.insights) {
        return DefaultGroupsIDs.insights;
    }
    return getUuid4();
};

export const createPortletGroup = () => {
    return {
        exec: '',
        title: DefaultGroupsIDs.insights,
        id: getGroupId(DefaultGroupsIDs.insights),
        type: HomepageGroupType.portlet,
        items: []
    };
};

export const createShortcutGroup = () => {
    return {
        exec: '',
        title: DefaultGroupsIDs.shortcuts,
        id: getGroupId(DefaultGroupsIDs.shortcuts),
        type: HomepageGroupType.tile,
        items: []
    };
};

export const findKeyByItem = (map: Map<string, Group>, targetItem: string): string | undefined => {
    for (const [key, value] of map.entries()) {
        if (value.items.find(item => item.exec === targetItem)) {
            return key;
        }
    }
    return undefined;
};

export const isGroupUnderLimit = (groups: Map<string, Group>) => {
    return groups.size < MAX_GROUPS_COUNT;
};

export const setDynamicColumnGap = (
    parentElement: HTMLDivElement,
    itemWidth: number,
    portletMinWidth: number = 590,
    minGap: number = 8
) => {
    // Select the parent element
    if (!parentElement) {
        console.error('Parent element not found');
        return;
    }

    // Get the computed width of the parent element
    const parentWidth = parentElement.clientWidth;
    // Calculate the number of items that fit in the parent element
    const itemsFit = Math.floor((parentWidth - minGap) / (itemWidth + minGap));

    // Calculate the remaining space after fitting the items
    const remainingSpace = parentWidth - itemsFit * itemWidth;

    // Calculate the gap value, ensuring it is at least the minimum gap
    const gapValue = Math.max(Math.floor(remainingSpace / (itemsFit + 1)), minGap);

    document.body.style.setProperty('--homepage-column-gap', `${gapValue}px`);

    // Calculate the width of the portlets if we decide to support it

    const portletSpace = parentWidth - gapValue * 2;
    if (portletSpace < portletMinWidth) {
        document.body.style.setProperty('--homepage-portlet-width', `${portletSpace}px`);
    } else {
        document.body.style.removeProperty('--homepage-portlet-width');
    }
    // const portletCount = Math.round(portletSpace / (portletMinWidth + gapValue));
    // const portletWidth = portletCount <= 1 ? portletSpace : Math.round((portletSpace / portletCount) - gapValue);
    // const portletMaxWidth = 600;

    // parentElement.style.setProperty("--homepage-portlet-width", `${Math.min(portletWidth, portletMaxWidth)}px`);

    // refresh the iframes directly after the gap is set
    // parentElement.querySelectorAll('iframe').forEach((iframe: HTMLIFrameElement) => {
    // we can try to use `reload method` if our host is whitelisted by the iframe party
    // iframe.contentWindow.location.reload();
    //     const src = iframe.src;
    //     iframe.src = '';
    //     iframe.src = src;
    // });
};
